module.exports = __webpack_public_path__ + "img/Veritas.0cc5d9f4.png";